import * as d3 from 'd3';
import { LayoutNode } from '../graph/types';
import { ThemeColors } from './theme';

const NODE_WIDTH = 140;
const NODE_HEIGHT = 60;
const RX = 8;

export function renderNodes(
  container: d3.Selection<SVGGElement, unknown, null, undefined>,
  nodes: LayoutNode[],
  colors: ThemeColors
): void {
  const groups = container
    .selectAll<SVGGElement, LayoutNode>('g.node')
    .data(nodes, (d: LayoutNode) => d.id)
    .join('g')
    .attr('class', 'node')
    .attr('transform', (d) => `translate(${d.x - d.width / 2}, ${d.y - d.height / 2})`)
    .style('cursor', 'pointer');

  groups
    .append('rect')
    .attr('width', (d) => d.width)
    .attr('height', (d) => d.height)
    .attr('rx', RX)
    .attr('fill', colors.nodeFill)
    .attr('stroke', (d) => colors.opColors[d.type] ?? colors.nodeStroke)
    .attr('stroke-width', 2);

  groups
    .append('text')
    .attr('x', NODE_WIDTH / 2)
    .attr('y', NODE_HEIGHT / 2 - 6)
    .attr('text-anchor', 'middle')
    .attr('dominant-baseline', 'middle')
    .attr('fill', colors.nodeText)
    .attr('font-size', '13px')
    .attr('font-weight', '600')
    .text((d) => d.label);

  groups
    .append('text')
    .attr('x', NODE_WIDTH / 2)
    .attr('y', NODE_HEIGHT / 2 + 12)
    .attr('text-anchor', 'middle')
    .attr('dominant-baseline', 'middle')
    .attr('fill', colors.nodeSublabel)
    .attr('font-size', '10px')
    .text((d) => d.sublabel ?? shapeString(d.outputShape));

  groups.each(function (d) {
    const title = d3.select(this).selectAll('title').data([null]).join('title');
    const lines: string[] = [d.label];
    if (d.sublabel) lines.push(d.sublabel);
    if (d.formula) lines.push(d.formula);
    lines.push(`shape: ${shapeString(d.outputShape)}`);
    if (d.params?.param_count) lines.push(`params: ${d.params.param_count.toLocaleString()}`);
    title.text(lines.join('\n'));
  });
}

function shapeString(shape: (number | string)[]): string {
  if (shape.length === 0) return 'scalar';
  return `[${shape.join(', ')}]`;
}
